import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postStartTestMigration = (token, tenantId) => {
    return fetch(`${apiUrl}start_test_migration/${tenantId}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });
}

export default postStartTestMigration
